/* DT · Beginnerspakket-showcase: variantkeuze, prijs los vs. set, binnenkomst. Geen afhankelijkheden. */
(function () {
  'use strict';

  function money(cents, fmt) {
    function f(n, d, ts, ds) {
      var parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    }
    var m = (fmt || '€{{amount_with_comma_separator}}').match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = f(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = f(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = f(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = f(cents, 2, "'", '.'); break;
      default: v = f(cents, 2, ',', '.');
    }
    return (fmt || '€{{amount_with_comma_separator}}').replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function srcset(url) {
    if (!url) return '';
    return [360, 480, 640, 800, 1000, 1200].map(function (w) {
      return url.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function tick(el, text) {
    if (!el || el.textContent === text) return;
    el.textContent = text;
    el.classList.remove('is-ticking'); void el.offsetWidth; el.classList.add('is-ticking');
  }

  function Stage(root) {
    var dataEl = root.querySelector('[data-dt-ss-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var fmt = data.money;
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-dt-ss-opt]'));
    var idInput = root.querySelector('[data-dt-ss-id]');
    var img = root.querySelector('[data-dt-ss-img]');
    var photo = img && img.parentNode;
    var add = root.querySelector('[data-dt-ss-add]');
    var addTxt = root.querySelector('[data-dt-ss-addtxt]');
    var link = root.querySelector('[data-dt-ss-url]');
    var q = function (s) { return root.querySelectorAll(s); };

    function selected() {
      return opts.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function find(sel) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (sel[j] !== null && v.o[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(sel) {
      opts.forEach(function (fs, oi) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var trial = sel.slice(); trial[oi] = inp.value;
          var v = find(trial);
          inp.closest('.dt-ss__chip').classList.toggle('is-unavailable', !v || !v.a);
        });
      });
    }

    function update() {
      var sel = selected();
      var v = find(sel);
      markAvailability(sel);
      opts.forEach(function (fs, oi) {
        var lg = fs.querySelector('[data-dt-ss-legend]');
        if (lg && sel[oi] !== null) lg.textContent = sel[oi];
      });
      if (!v) {
        if (add) add.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;

      // losse prijs = som van de onderdelen bij deze keuze
      var loose = 0, ok = data.parts.length > 0;
      data.parts.forEach(function (part, pi) {
        var hit = part.opt >= 0 ? part.map[v.o[part.opt]] : part.fix;
        var lineEl = root.querySelector('[data-dt-ss-line="' + pi + '"]');
        var tile = root.querySelector('[data-dt-ss-part="' + pi + '"]');
        if (!hit) { ok = false; return; }
        var line = hit.p * (part.q || 1);
        loose += line;
        if (lineEl) lineEl.textContent = money(line, fmt);
        if (tile) {
          var val = tile.querySelector('[data-dt-ss-part-val]');
          if (val && part.opt >= 0) val.textContent = v.o[part.opt];
          var pimg = tile.querySelector('[data-dt-ss-part-img]');
          if (pimg && hit.i) {
            var nu = hit.i;
            if (pimg.getAttribute('data-cur') !== nu) {
              pimg.setAttribute('data-cur', nu);
              pimg.removeAttribute('srcset');
              pimg.src = nu;
            }
          }
        }
      });
      var save = loose - v.p;
      var showLoose = ok && save > 0;
      q('[data-dt-ss-receipt], [data-dt-ss-savewrap], [data-dt-ss-tag], [data-dt-ss-note]').forEach(function (el) { el.hidden = !showLoose; });
      if (showLoose) {
        var l = root.querySelector('[data-dt-ss-loose]'); if (l) l.textContent = money(loose, fmt);
        q('[data-dt-ss-save]').forEach(function (el) { tick(el, money(save, fmt)); });
      }
      tick(root.querySelector('[data-dt-ss-price]'), money(v.p, fmt));
      var cw = root.querySelector('[data-dt-ss-comparewrap]');
      if (cw) {
        cw.hidden = showLoose || !(v.c > v.p);
        var c = root.querySelector('[data-dt-ss-compare]'); if (c && v.c) c.textContent = money(v.c, fmt);
      }
      if (add) add.disabled = !v.a;
      if (addTxt) addTxt.textContent = v.a ? data.add : data.soldout;
      if (link) link.href = data.url + '?variant=' + v.id;

      if (img && v.i && img.getAttribute('data-cur') !== v.i) {
        img.setAttribute('data-cur', v.i);
        if (photo) photo.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          img.srcset = srcset(v.i); img.src = v.i; img.alt = v.alt || img.alt;
          if (photo) photo.classList.remove('is-swapping');
        };
        pre.src = v.i;
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio' && e.target.closest('[data-dt-ss-opt]')) update();
    });
    markAvailability(selected());
  }

  function init(scope) {
    (scope || document).querySelectorAll('.dt-ss').forEach(function (sec) {
      if (sec.dataset.dtSsInit) return;
      sec.dataset.dtSsInit = '1';
      var stages = sec.querySelectorAll('[data-dt-ss]');
      stages.forEach(function (st) { new Stage(st); });
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      sec.classList.add('dt-ss--js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
      stages.forEach(function (st) {
        var r = st.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) st.classList.add('is-in'); else io.observe(st);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
